<template>
    <div style="min-height:85vh">

        <div style="margin: 16px 0;display:flex">
            <a-breadcrumb style="margin-top:auto;margin-bottom:auto">
                <a-breadcrumb-item style="font-size:30px;">Edit Offer Code</a-breadcrumb-item>
                <!-- <a-breadcrumb-item>Bill</a-breadcrumb-item> -->
            </a-breadcrumb>

            <a-button style="margin-top:auto;margin-bottom:auto;margin-left:20px" type="primary">
                <router-link to="/admin/addoffercode">
                    Add Offer Code
                </router-link>
            </a-button>
        </div>

        <div style="display:flex;margin-top:20px">
            <div style="width:200px;text-align:left;margin-top:auto;margin-bottom:auto">Offer Code Name</div>
            <a-input style="width:300px;margin-top:auto;margin-bottom:auto" v-model="name" placeholder="" />
        </div>
        <div style="display:flex;margin-top:20px">
            <div style="width:200px;text-align:left;margin-top:auto;margin-bottom:auto">Offer Code Value</div>
            <a-input-number style="width:300px;margin-top:auto;margin-bottom:auto" v-model="value" placeholder="" />
        </div>
        <div style="display:flex;margin-top:20px">
            <div style="width:200px;text-align:left;margin-top:5px;">Description</div>
            <a-textarea style="width:300px;margin-top:auto;margin-bottom:auto" v-model="description" placeholder=""
                :auto-size="{ minRows: 6, maxRows: 8 }" />
        </div>

        <div style="display:flex;margin-top:20px">
            <a-button style="margin-top:auto;margin-bottom:auto;" type="primary" v-on:click="saveOfferCode">
                Save Offer Code
            </a-button>
        </div>
    </div>
</template>
<script>

import { api } from '../helpers/Helpers';

export default {
    data() {
        return {
            name: '',
            value: '',
            description: '',
            creatorId: '',
            createdDate: '',

            offerCodeId: '',
        };
    },

    created: function () {
        this.getOfferCodeInfo();
    },
    methods: {
        getOfferCodeInfo: async function () {
            const queryString = window.location.search;
            const parameters = new URLSearchParams(queryString);
            const _id = parameters.get('id');
            if (_id != null) {
                this.offerCodeId = _id;
                const res = await api.getOfferCode(_id);
                this.name = res.name;
                this.value = res.value;
                this.description = res.description;
                this.creatorId = res.creatorId;
                this.createdDate = res.createdDate;
            }
        },
        saveOfferCode: async function () {
            const offerCodeData = {
                name: this.name,
                value: this.value,
                description: this.description,
                creator: this.creatorId,
                createdDate: this.createdDate,
                updatedDate: new Date()
            };

            const res = await api.updateOfferCode(this.offerCodeId, offerCodeData);

            if (res != undefined && res != "") {
                this.$message.success('update success!');
                this.$emit('close');
                this.$router.push({ path: 'offercodes' })
            }
            else {
                this.$message.error('update failed!');
            }
        }
    }
}
</script>